import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAnalyticsStats } from '../../store/actions/analytics/analytics.action';
import Overview from '../../components/Analytics/Data/Overview';
import PieceSubscriptionsChart from '../../components/Analytics/Data/PieceSubscriptionsChart';
import UsersSubscriptionsChart from '../../components/Analytics/Data/UsersSubscriptionChart';
import PageLoader from '../../components/Common/PageLoader';
import '../../styles/analytics.scss';

const DataAnalyticsContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const analytics_stats = useSelector((state) => state.analytics?.stats || {});
  const categories = useSelector((state) => state.auth?.categories || []);
  const isFetching = useSelector((state) => state.analytics?.isFetching || false);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      if (!categories || !Array.isArray(categories)) {
        setAccessDenied(true);
        return;
      }

      const analyticsCategory = categories.find((category) => category.link === 'analytics');
      if (analyticsCategory) {
        setMode(analyticsCategory.mode);
        setAccessDenied(false);
      } else {
        setAccessDenied(true);
      }
    } catch (err) {
      console.error('Error setting access:', err);
      setAccessDenied(true);
    }
  }, [categories]);

  // Initialize on mount
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getAnalyticsStats());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return (
      <div className="access-denied">
        <h3>Access Denied</h3>
        <p>This category is not accessible to the logged in user.</p>
      </div>
    );
  }

  return (
    <div className="data-analytics-container">
      <Overview data={analytics_stats?.overview} />
      <PieceSubscriptionsChart data={analytics_stats?.piece_subscriptions} />
      <UsersSubscriptionsChart data={analytics_stats?.user_subscriptions} />
    </div>
  );
};

export default DataAnalyticsContainer;
